import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { appConfig } from "../AppConfig/variables";
import { getLastRefreshDate } from "../../api/globalApi";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "../../assets/css/custom.css";
import mcd_logo from "../../assets/img/phase3/mcd_logo.svg";
import settings from "../../assets/img/phase3/settings.svg";
import question_mark from "../../assets/img/phase3/question_mark.svg";
import UserInfo from "../Auth/UserInfo";
import { getUserRoleInfoApi } from "../../api/userApi";
import { useMsal } from "@azure/msal-react";

const Header = (props) => {
  const {
    pathName,
    onChangeHeader,
    showScatteringChart,
    setShowScatteringChart,
    setShowPreferencesModal,
  } = props;
  const [lastRefDate, setLastRefDate] = useState('')
  const { instance, accounts } = useMsal();
  const dispatch = useDispatch();
  const location = useLocation();
  const lastRefreshDate = useSelector((state) => state.global.lastRefreshDate);
  const username = accounts[0] && accounts[0].username;

  useEffect(() => {
    dispatch(getLastRefreshDate());
    dispatch(getUserRoleInfoApi(username));

    // eslint-disable-next-line
  }, [username]);

  const setSwt = () => {
    setShowScatteringChart(!showScatteringChart);

    onChangeHeader(showScatteringChart ? "Risk Alerts" : "Strategic Risks");
  };

  useEffect(() => {
    if(lastRefreshDate) {
      const { operational, strategic, insights} = lastRefreshDate;
      if(location.pathname === '/Summary' 
        || location.pathname === '/Management' || location.pathname === '/workflow') {
        setLastRefDate(operational)
      } else if(location.pathname === '/StrategicSummary' 
        || location.pathname === '/StrategicSummary/Capacity') {
        setLastRefDate(strategic)
      } else if(location.pathname === '/insight') {
        setLastRefDate(insights)
      }
    }
  }, [location.pathname, lastRefreshDate])

  return (
    <Navbar key="false" expand="true" className="mb-4">
      <div className="flex-row header-wrapper">
        <div className="pdl1rem">
          <img className="top-logo" src={mcd_logo} alt="McD Logo" /> Ingredient
          Resiliency Control Tower
        </div>
        <Nav className="nav-icons">
          {lastRefDate && (
            <div className="flex-row align-items-center last-refresh-date">
              Last Refresh Date: {lastRefDate}
            </div>
          )}
          {/* {(pathName === "Strategic Risks" || pathName === "Risk Alerts") && (
                <FormCheck
                  type="switch"
                  className="contentEnd activeRiskSwitchBtn"
                >
                  <FormCheck.Input
                    checked={showScatteringChart}
                    onClick={setSwt}
                    id="activeRiskSwitchInput"
                  />
                </FormCheck>
              )} */}
          <Nav.Link
            href={appConfig["help_doc"]}
            className="contentEnd"
            target="_blank"
          >
            <img className="header-icon" src={question_mark} alt="" />{" "}
          </Nav.Link>
          <Nav.Link href="#" className="contentEnd">
            <img className="header-icon" src={settings} alt="" />
          </Nav.Link>
          <Nav.Link className="flex-row align-items-center user-info">
            <UserInfo setShowPreferencesModal={setShowPreferencesModal} />
          </Nav.Link>
        </Nav>
      </div>
    </Navbar>
  );
};

export default Header;
